<template>
    <b-row class="">
        <b-col
            cols="12"
            xl="4"
            lg="5"
            md="5"
        >
            <user-info-card/>
        </b-col>
        <b-col
            cols="12"
            xl="8"
            lg="7"
            md="7"
        >
            <user-plan-view/>
            <user-activity-timeline/>
        </b-col>
    </b-row>
</template>
<script>
import {
  BRow, BCol, BLink,
} from 'bootstrap-vue-3'
import UserInfoCard from './layout/UserInfoCard.vue'
import UserPlanView from './layout/UserPlanView.vue'
import UserActivityTimeline from './layout/UserActivityTimeline.vue'
import UserInvoiceView from './layout/UserInvoiceView.vue'
export default {
    name:'AdminUserView',
    components:{
        BRow,
        BCol,
        BLink,
        UserInfoCard,
        UserPlanView,
        UserActivityTimeline,
        UserInvoiceView,
    },
    setup() {
      return {}
    },
    created() {
    },
    methods: {
    },
}
</script>
